import React, { useRef, useState, useEffect } from "react";

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IComposableImgProps extends IBaseProps {
  imgList: string[];
  onLoad?: (index: number) => void;
  onError?: (index: number) => void;
}

/**
 * 根据容器宽度，计算img标签的宽度，动态设置img标签的style
 * 在css里设置img的width为100%，会导致html2canvas截图时，img宽度会比canvas画板宽度小，就会有一部分留白区域
 * 需要把img标签的宽度设置为固定的像素，html2canvas截图时，img才不会有留白
 * @returns node节点ref、img标签的宽度
 */
function useImgWidth(node: React.RefObject<HTMLUListElement>) {
  const [width, setWidth] = useState('');

  useEffect(() => {
    if (!node?.current) return;
    const widthTmp = getComputedStyle(node.current).getPropertyValue('width');
    setWidth(widthTmp);
  }, []);

  return width;
}

const ComposableImg: React.FC<IComposableImgProps> = (props) => {
  const {imgList, onLoad, onError} = props;

  const node = useRef<HTMLUListElement>(null);

  const width = useImgWidth(node);

  return (
    <ul ref={node} className="dbg-composable-img-list">
      {
        imgList?.map((imgItem, imgIdx) => (
          <li key={imgItem} className="dbg-composable-img-item">
            <img
              style={{ width }}
              className="dbg-composable-img"
              crossOrigin="anonymous"
              // 解决跨域：第三方图片存在防盗链，不发送referrer
              referrerPolicy="no-referrer"
              src ={imgItem}
              onLoad={() => {
                onLoad?.(imgIdx);
              }}
              onError={() => {
                onError?.(imgIdx);
              }}
            />
          </li>
        ))
      }
    </ul>
  );
};

export default ComposableImg;
